import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HttpUrlGenerator } from '@ngrx/data';
import { SiteInterface } from '@shared/api';
import { CustomDefaultDataService } from '../../custom-default-data-service.class';
import { EntityTypeEnum } from '../../entity.interface';

@Injectable({
  providedIn: 'root',
})
export class SelectSitesDataService extends CustomDefaultDataService<SiteInterface> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super(EntityTypeEnum.SelectSite, http, httpUrlGenerator);
  }
}
